import { Component, inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { Sessao } from '../../shared/model/sessao/sessao.model';
import { CommonModule } from '@angular/common';
import { SelectOneComponent } from '../../shared/components/select-one/select-one.component';
import { SelectMultipleComponent } from '../../shared/components/select-multiple/select-multiple.component';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { SessaoFiltro } from '../../shared/model/sessao/sessao-filtro.model';
import { IdNome } from '../../shared/model/id-nome.model';
import { ProgressBarDataComponent } from '../../shared/components/progress-bar-data/progress-bar-data.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import {provideNativeDateAdapter} from '@angular/material/core';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import {FluxoService} from '../../shared/service/fluxo-service';
import {FluxoBusca} from '../../shared/model/fluxo/fluxo-busca-model';
import {UsuarioService} from '../../shared/service/usuario.service';
import {Usuario} from '../../shared/model/usuario/usuario.model';
import {MethodsUtils} from '../../shared/util/methods.utils';
import {ModalConfirmacaoComponent} from '../../shared/modais/modal-confirmacao/modal-confirmacao.component';
import {EtapaSelect} from '../../shared/model/etapa/etapa-select-model';
import {EtapaService} from '../../shared/service/etapa-service';
import {CanalService} from '../../shared/service/canal.service';
import {FluxoSelect} from '../../shared/model/fluxo/fluxo-select-model';
import {VariavelService} from '../../shared/service/variavel.service';
import {VariavelSelect} from '../../shared/model/variavel/variavel-select.model';
import {MatTooltip} from '@angular/material/tooltip';
import { EtapaBusca } from '../../shared/model/etapa/etapa-busca-model';
import { MsgService } from '../../shared/service/msg.service';
import {CardSessaoMobileComponent} from '../mobile/utils/card-sessao-mobile/card-sessao-mobile.component';

@Component({
  selector: 'app-modal-sessao-global',
  standalone: true,
  imports: [
    CommonModule,
    SelectOneComponent,
    SelectMultipleComponent,
    ButtonPadraoComponent,
    ProgressBarDataComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    FormsModule,
    FormFieldComponent,
    MatTooltip,
    CardSessaoMobileComponent,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './modal-sessao-global.component.html',
  styleUrl: './modal-sessao-global.component.css'
})
export class ModalSessaoGlobalComponent implements OnInit {
  private readonly dialog = inject(MatDialog);
  private readonly dialogRef = inject(MatDialogRef<ModalSessaoGlobalComponent>);
  public data = inject<{ isFiltro: boolean; isVisualizacao?: boolean; filtros?: SessaoFiltro; isPrimeiraAberturaFiltros?: boolean, sessao?: Sessao }>(MAT_DIALOG_DATA);
  private readonly fluxoService = inject(FluxoService);
  private readonly etapaService = inject(EtapaService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly canalService = inject(CanalService);
  private readonly variavelService = inject(VariavelService);
  private readonly msgService = inject(MsgService);

  isFiltro = this.data.isFiltro;
  isVisualizacao = !!this.data.isVisualizacao;

  //filtros
  atividadeOpcoes: IdNome[] = [
    { id: 0, nome: 'Todos' },
    { id: 1, nome: 'Ativo' },
    { id: 2, nome: 'Inativo' }
  ];
  atividadeSelecionada: IdNome = new IdNome();
  fluxosSelect: FluxoBusca[] = [];
  etapasSelect: EtapaSelect[] = [];

  operadores: Usuario[] = [];
  canais: IdNome[] = [];
  variaveis: VariavelSelect[] = [];

  filtrosObj = new SessaoFiltro();

  carregandoFluxos = true;
  carregandoOperadores = true;
  carregandoCanais = true;
  carregandoEtapas = true;
  inatividadeAtiva = false;
  readOnly = false;

  isPrimeiraAberturaFiltros = true;

  //detalhes
  sessao: Sessao = new Sessao()

  larguraTela?: number;

  ngOnInit() {
    this.buscarLarguraTela();
    if (this.isFiltro) {
      this.inicializacaoFiltros()
    } else {
      this.inicializacaoSessaoObj()
    }
  }

  buscarLarguraTela(){
    this.larguraTela = window.innerWidth;
  }

  validarMobile(): boolean {
    if(this.larguraTela){
      return this.larguraTela < 1250;
    }
    return false;
  }

  inicializacaoFiltros(){
    if (this.data.filtros) {
      this.isPrimeiraAberturaFiltros = this.data.isPrimeiraAberturaFiltros ?? true;
      this.filtrosObj = this.data.filtros;
      this.atividadeSelecionada = this.filtrosObj.atividade ? this.filtrosObj.atividade : this.atividadeOpcoes.find(opcao => opcao.id === 1) || new IdNome();
    }
    this.buscarFluxos();
    this.buscarEtapas();
    this.buscarOperadores();
  }

  inicializacaoSessaoObj(){
    this.sessao = this.data.sessao ? this.data.sessao : new Sessao();
    if (this.isVisualizacao) {
      if (this.sessao.id) this.buscarVariaveisSessao(this.sessao.id);
    } else {
      this.buscarCanais();
      if (this.sessao.canal && this.sessao.canal.id) this.buscarOperadorPeloCanal(this.sessao.canal.id);
      this.buscarFluxos();
      if (this.sessao.fluxo && this.sessao.fluxo.id) {
        this.buscarEtapasPeloFluxo(this.sessao.fluxo.id);
      } else {
        this.buscarEtapas();
      }
    }
  }

  salvar() {
    if (this.isFiltro) {
      this.filtrosObj.atividade = this.atividadeSelecionada;
      this.dialogRef.close(this.filtrosObj);
      return;
    }

    if(this.sessao.canal?.id && !this.sessao.operador?.id && this.operadores?.length > 0){
      this.msgService.msgAdvertencia("Favor selecionar um operador.")
      return;
    }

    this.dialog.open(ModalConfirmacaoComponent, {
      data: { texto: 'Deseja salvar sessão?' }
    }).afterClosed().subscribe({
      next: (res: boolean) => {
        if (res) { this.dialogRef.close(this.sessao); }
      }
    });
  }

  inativarSessao(){
    this.sessao.ativo = false
    this.dialogRef.close(this.sessao);
  }

  cancelar() {
    this.dialogRef.close(null);
  }

  selecionarCanal(event: IdNome) {
    if (!this.sessao.canal || (this.sessao.canal && event.id !== this.sessao.canal.id)) {
      this.buscarOperadorPeloCanal(event.id!);
    }
    this.sessao.canal = event;
  }

  selecionarEtapa(event: EtapaBusca) {
    this.sessao.etapa = event;
    if(!event.canal){
      this.sessao.canal = undefined;
    }else{
      this.sessao.canal = event.canal;
    }
  }


  selecionarFluxo(event: FluxoSelect) {
    if (!this.sessao.fluxo || (this.sessao.fluxo && this.sessao.fluxo.id !== event.id)) {
      this.buscarEtapasPeloFluxo(event.id!);
    }
    this.sessao.fluxo = event;
  }

  private buscarEtapas() {
    this.carregandoEtapas = true;
    this.etapaService.buscarTodasEtapasSelect().subscribe({
      next: etapas => this.etapasSelect = etapas,
      complete: () => this.carregandoEtapas = false
    });
  }

  private buscarEtapasPeloFluxo(fluxoId: number) {
    this.carregandoEtapas = true;
    this.etapaService.buscar(fluxoId).subscribe({
      next: etapas => this.etapasSelect = etapas,
      complete: () => this.carregandoEtapas = false
    });
  }

  private buscarOperadores() {
    this.carregandoOperadores = true;
    this.usuarioService.buscarOperadoresPorGrupo().subscribe({
      next: operadores => this.operadores = operadores.sort((a, b) => MethodsUtils.ordenarAlfabeticamente(a.nome!, b.nome!)),
      complete: () => this.carregandoOperadores = false
    });
  }

  private buscarOperadorPeloCanal(canalId: number) {
    this.usuarioService.buscarOperadoresPorGrupoECanal(canalId).subscribe({
      next: res => this.operadores = res,
      complete: () => this.carregandoOperadores = false
    });
  }

  private buscarCanais() {
    this.canalService.buscarCanaisAtivoDoGrupo().subscribe({
      next: res => this.canais = res,
      complete: () => this.carregandoCanais = false
    });
  }

  private buscarFluxos() {
    this.carregandoFluxos = true;
    this.fluxoService.buscar().subscribe({
      next: fluxos => this.fluxosSelect = fluxos,
      complete: () => this.carregandoFluxos = false
    });
  }

  private buscarVariaveisSessao(sessaoId: number) {
    this.variavelService.buscarVariavelSelectSessao(sessaoId).subscribe({
      next: res => this.variaveis = res
    });
  }
}
